import React from 'react';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { IUserSchemaPartial } from '../../../graphql/type/user';
import useKeepitalRoutes from '../_hook/useKeepitalRoutes';

interface IProps {
  user?: IUserSchemaPartial;
  useAdminLink?: boolean;
  useIndexLink?: boolean;
  width?: number;
  height?: number;
  avatarOnly?: boolean;
}

const useStyles = makeStyles<Theme, IProps>((theme: Theme) => ({
  avatar: {
    width: ({ width }) => theme.spacing(width || 5),
    height: ({ height }) => theme.spacing(height || 5),
    color: theme.palette.mode === 'dark' ? 'inherit' : undefined,
  },
  avatarLink: {
    color: theme.palette.mode === 'dark' ? 'inherit' : undefined,
    textDecoration: 'none',
  },
}));

export default function SchemaUserAvatar(props: IProps) {
  const { user, useAdminLink, useIndexLink, avatarOnly, width, height } = props;
  const classes = useStyles(props);

  if (!user) {
    return (
      <Tooltip title="Deleted User">
        <Avatar className={classes.avatar}>N</Avatar>
      </Tooltip>
    );
  }

  const { profile } = user;
  const { path: keepitalPath } = useKeepitalRoutes();

  let text = '';
  if (profile && profile.name && profile.name.firstname)
    text += `${profile.name.firstname} `;
  if (profile && profile.name && profile.name.lastname)
    text += profile.name.lastname;

  const avatar =
    user &&
    user.profile &&
    user.profile.media &&
    user.profile.media.images &&
    user.profile.media.images.avatar
      ? user.profile.media.images.avatar.find((item) => item.status)
      : null;

  const avatarComponent = avatar ? (
    <Avatar
      className={classes.avatar}
      alt={text}
      src={avatar.filenameSmallUrl || avatar.filenameUrl}
    />
  ) : (
    <Avatar className={classes.avatar}>{text[0]}</Avatar>
  );

  if (avatarOnly) return avatarComponent;

  const avatarComponentWithTooltip = (
    <Tooltip title={text}>{avatarComponent}</Tooltip>
  );

  if ((useAdminLink || useIndexLink) && user._id) {
    return (
      <a
        className={classes.avatarLink}
        href={
          useAdminLink
            ? keepitalPath('user.dashboard', {
                userID: user._id as string,
              })
            : keepitalPath('user.index', {
                userID: user._id as string,
              })
        }
        target="_blank"
        rel="noreferrer"
      >
        {avatarComponentWithTooltip}
      </a>
    );
  }

  return avatarComponentWithTooltip;
}
